import React, { useEffect, useState } from 'react';
import { useParams, useLocation } from 'react-router';
import { useDispatch, useSelector } from 'react-redux';
import tawkTo from 'tawkto-react';
import { useHistory } from 'react-router-dom';
import queryString from 'query-string';
//api
import api from '@/api';
// components
import RegistrationCustomFields from '@/components/landing-page-templates/ConfigLandingPage/ConfigAuthComponents/RegistrationCustomFields';
import CheckinValidation from '@/components/landing-page-templates/ConfigLandingPage/ConfigAuthComponents/CheckinValidation';
import TermsAndConditions from '@/components/landing-page-templates/ConfigLandingPage/DisplayMessageComponents/TermsAndConditions';
import NewLandingPageCountdownTimer from '@/components/NewLandingPageCountdownTimer';
import { IAccountRegistrationEnum } from '@/models/account/types';
import { selectRegistrationStep } from '@/models/account';
import Notification from '@/components/ui/Notification';
import LandingPageAccountFormSection from '@/components/landing-page-templates/ConfigLandingPage/ConfigAuthComponents/AuthForms/LandingPageAccountFormSection';
import {
  ArrowLeft,
  TicketIcon,
} from '@/components/landing-page-templates/ConfigLandingPage/LandingPageIcons';
// styles
import styles from './styles.module.scss';
// utils
import { useMemoizedSelector } from '@/hooks/use-memoized-selector';
import { _isUndefined, _isEmpty as _isEmptyObj } from '@/utils/jsHelpers/obj';
//types
import {
  IEventCheckinType,
  ILoginType,
} from '@/components/landing-page-templates/ConfigLandingPage/types';
import { IEventStatusOptions } from '@/models/event/types';
import {
  INotificationContentTypes,
  INotificationPositionTypes,
} from '@/components/ui/Notification/types';
// models
import { makeSelectEventById, selectTawkToDetails } from '@/models/event';
import LogoutPromptForNotCheckedinUsers from '@/components/landing-page-templates/ConfigLandingPage/DisplayMessageComponents/LogoutPromptForNotCheckedinUsers';
import useRegistrationRequiredFieldValidation from '@/hooks/use-registration-required-field-validation';
import Text, { ITextColors } from '@/components/ui/content/Text';
import classnames from 'classnames';
import { ITicketingFlowType } from './types';
import MagicLinkConfirmationModal from './MagicLinkConfirmationModal';
import { getIsCookieEnabled, hexToRgb } from '@/utils/helpers';
import CookiesDisabledLabel from '../DisplayMessageComponents/CookiesDisabledLabel';
import BasicCheckinForm from '../../ConfigurableLandingPage/LandingPageForms/BasicCheckInForm';
import { getEmbedLegacyCustomFormAuthEnabled } from '../../ConfigurableLandingPage/LandingPage/BasicLandingPage/legacyAuthConfig';
import useEventStatus from '@/hooks/use-event-status';
import { EEventType } from '@/types/event';

const isCookieEnabled = getIsCookieEnabled();

const ConfigAuthComponents = ({
  currentUser,
  currentUserEventPermissions,
  landingPageObject,
  buttonStyle,
  role,
  isSpeakerPage,
  isEmbedView = false,
  setIsEventEnded,
  setIsEarlyEvent,
  isLoginFlowOnly: showLoginFlowOnly = false,
}) => {
  const {
    eventEntryType,
    checkInEnableTime,
    checkInDisableTime,
    formBgColour,
    formFontColour,
    magicLinkEnabled,
    registrationCustomFieldList,
    eventLandingPageDisclaimers,
    guestModeEnabled,
    attendeeAuthType,
    speakerMagicLinkEnabled,
    landingPageTemplateName,
  } = landingPageObject;

  const { search } = useLocation();

  const searchParams = queryString.parse(search);

  let { re, mt } = searchParams;

  // if (Object.keys(zyloInvalidSpeakerMagicTokenMapping).includes(mt)) {
  //   const { token, speakerId } = zyloInvalidSpeakerMagicTokenMapping[mt];
  //   mt = token;
  //   re = speakerId;
  // }

  useEffect(() => {
    const root = document.documentElement;
    const formBgColourRGB = hexToRgb(formBgColour ? formBgColour : '#843DF5');
    root.style.setProperty('--background', formBgColour);
    root.style.setProperty(
      '--backgroundRGB',
      `${formBgColourRGB[0]}, ${formBgColourRGB[1]}, ${formBgColourRGB[2]}`,
    );
    root.style.setProperty('--font-color', formFontColour);
  }, [formBgColour, formFontColour]);

  const dispatch = useDispatch();
  const history = useHistory();
  const { eventId } = useParams<{ eventId: string }>();
  const event = useMemoizedSelector(makeSelectEventById, eventId);
  const eventRoleId: string =
    currentUserEventPermissions && currentUserEventPermissions.eventRoleId;
  const [showValidMessage, setValidMessage] = useState(false);
  const registrationStep = useSelector(selectRegistrationStep);
  const tawkToDetails = useSelector(selectTawkToDetails);

  const [notificationMode, setNotificationMode] = useState<boolean>(false);

  const [checkRegistrationExists, setCheckRegistrationExists] = useState<
    boolean
  >(true);

  const [email, setEmail] = useState(currentUser?.email);
  const [showLoginOption, setShowLoginOption] = useState(showLoginFlowOnly);
  const [isLoginFlowOnly, setIsLoginFlowOnly] = useState(showLoginFlowOnly);
  const isSeriesEvent = event?.type === EEventType.SERIES;
  const isWebinar = event?.type === EEventType.WEBINAR;

  // below hook for setting default login flow for flex events and auth popups
  useEffect(() => {
    if (event?.isFlex || showLoginFlowOnly) {
      setShowLoginOption(true);
      setIsLoginFlowOnly(true);
    }
  }, [event?.isFlex, showLoginFlowOnly]);

  const [
    isRegisteredOrAlreadyRegistered,
    setIsRegisteredOrAlreadyRegistered,
  ] = useState(false);
  const [otpInitiated, setOtpInitiated] = useState(false);

  const setMessageToParentWindow = (
    windowMessage: string,
    redirectUrl: string,
  ) => {
    if (isEmbedView || isLoginFlowOnly) {
      let myParent = window.top;
      if (window.parent !== window.top) {
        myParent = window.parent;
      }
      myParent?.postMessage(
        {
          action: windowMessage,
          redirectUrl: redirectUrl,
        },
        '*',
      );
    }
  };

  useEffect(() => {
    //This api updates the count of landing page visitors
    api.pageBuilder.updateLandingPageVisitors(eventId);
  },[eventId])

  const checkInEnabledBeforeEventMinutes = checkInEnableTime;
  const checkInDisableAfterEventMinutes = checkInDisableTime;
  const { isEventLive, isEventDone, isEventBefore } = useEventStatus({event, checkInEnabledBeforeEventMinutes,checkInDisableAfterEventMinutes })

  useEffect(() => {
    if (setIsEventEnded) {
      setIsEventEnded(isEventDone);
    }
  }, [isEventDone, setIsEventEnded]);

  useEffect(() => {
    if (setIsEarlyEvent) {
      setIsEarlyEvent(isEventBefore);
    }
  }, [isEventBefore, setIsEarlyEvent]);

  const redirectToAttendeePageForDuda = () => {
    api.pageBuilder.getLandingPageLink(eventId).then(({ data }) => {
      setMessageToParentWindow('REDIRECT_TO_ATTENDEE_PAGE', data.attendeeUrl);
    });
  };

  const handleCheckoutOpen = () => {
    setMessageToParentWindow('TICKETING_OPEN', '');
    setShowPaymentModal(true);
  };

  const onlyGuestAuthIsEnabled =
    guestModeEnabled && !magicLinkEnabled && attendeeAuthType.length === 0;

  //Check Mandatory fields and disclaimers are filled
  //If not show registeration form before entering the event
  const shouldUpdatePendingCustomFields = useRegistrationRequiredFieldValidation(
    eventRoleId,
    role,
    currentUserEventPermissions,
    registrationCustomFieldList,
    currentUser,
    eventLandingPageDisclaimers,
    event,
    isLoginFlowOnly,
  );

  if (isEmbedView && shouldUpdatePendingCustomFields) {
    setMessageToParentWindow('UPDATE_PENDING_CUSTOM_FIELDS', '');
  }

  const redirectToLandingPage = async (isTokenVerified: boolean) => {
    if (isEmbedView || isLoginFlowOnly) {
      if (!isTokenVerified) {
        setMessageToParentWindow('USER_UNAUTHORIZED', '');
      } else {
        setMessageToParentWindow('USER_AUTHORIZED', '');
      }
    }

    if (isEmbedView || isLoginFlowOnly) {
      // redirecting to embed form only
      history.push(
        `/embed/auth/event/${eventId}?embedMagicTokenVerified=${
          isTokenVerified ? 'true' : 'false'
        }&isLoginFlowOnly=${isLoginFlowOnly ? 'true' : 'false'}`,
      );
      return;
    }
    // if (isSpeakerPage) {
    //   history.push(`/p/event/${eventId}`);
    // } else {
    //   history.push(`/p/a/event/${eventId}`);
    // }

    let dudaLandingPageUrl;
    if(event.seriesParentEventId && !isSeriesEvent) {
      await api.pageBuilder.getLandingPageLink(event.seriesParentEventId).then(({ data }) => {
        dudaLandingPageUrl = data.attendeeUrl;
      });
    }

    const redirectEventId = event.seriesParentEventId ? event.seriesParentEventId : eventId;
    if (isSpeakerPage) {
      if(event.seriesParentEventId) {
        if(!isTokenVerified) {
          if(dudaLandingPageUrl && !isSeriesEvent) {
            window.location.replace(dudaLandingPageUrl);
          } else {
            history.push(`/p/event/${redirectEventId}`);
          }
        }
      } else {
        history.push(`/p/event/${eventId}`);
      }
    } else {
      if(event.seriesParentEventId) {
        if(!isTokenVerified) {
          if(dudaLandingPageUrl && !isSeriesEvent) {
            window.location.replace(dudaLandingPageUrl);
          } else {
            history.push(`/p/a/event/${redirectEventId}`);
          }
        }
      } else {
        history.push(`/p/a/event/${eventId}`);
      }
    }
  };

  const [
    magicLinkWithDifferentEmail,
    setMagicLinkWithDifferentEmail,
  ] = useState('');
  const [confirmDifferentEmailLogin, setConfirmDifferentEmailLogin] = useState(
    false,
  );

  useEffect(() => {
    if (isSpeakerPage) {
      return;
    }

    if (!isEventLive && !isEventDone && !isEventBefore) {
      return;
    }

    (async () => {
      if (magicLinkEnabled) {
        if (re && mt) {
          if(event.seriesParentEventId && !isEventLive) {
            redirectToLandingPage(false);
            return;
          }
          let isDifferentEmail = false;
          if (
            currentUser.accountId &&
            (!confirmDifferentEmailLogin || eventRoleId === null)
          ) {
            const { data } = await api.registration.getRegisteredEmail(re);
            if (data && currentUser.email !== data) {
              setMagicLinkWithDifferentEmail(data);
              setMessageToParentWindow('ACCOUNT_CHANGE_CONFIRMATION', '');
              isDifferentEmail = true;
              return;
            }
          }
          if (!isDifferentEmail) {
            api.registration
              .verifyMToken(eventId, mt, re)
              .then(res => {
                const data = res.data;
                dispatch({ type: 'account/setUserData', payload: { data } });
                redirectToLandingPage(true);
              })
              .catch(e => {
                redirectToLandingPage(false);
              });
          }
        } else if(event.seriesParentEventId) {
          redirectToLandingPage(false);
        }
      } else {
        if (re && mt) {
          redirectToLandingPage(false);
        }
      }
    })();
  }, [eventId, confirmDifferentEmailLogin, isEventLive, isEventDone, isEventBefore]);

  useEffect(() => {
    if (!isSpeakerPage) {
      return;
    }

    (async () => {
      if (speakerMagicLinkEnabled) {
        if (re && mt) {
          let isDifferentEmail = false;
          if (
            currentUser.accountId &&
            (!confirmDifferentEmailLogin || eventRoleId === null)
          ) {
            const { data } = await api.speaker.getSpeakerEmail(re);
            if (data != null && currentUser.email !== data) {
              setMagicLinkWithDifferentEmail(data);
              setMessageToParentWindow('ACCOUNT_CHANGE_CONFIRMATION', '');
              isDifferentEmail = true;
              return;
            }
          }
          if (!isDifferentEmail) {
            api.speaker
              .verifyMToken(eventId, mt, re)
              .then(res => {
                const data = res.data;
                dispatch({ type: 'account/setUserData', payload: { data } });
                redirectToLandingPage(true);
              })
              .catch(e => {
                redirectToLandingPage(false);
              });
          }
        } else if(event.seriesParentEventId) {
          redirectToLandingPage(false);
        }
      } else {
        if (re && mt) {
          redirectToLandingPage(false);
        }
      }
    })();
  }, [eventId, confirmDifferentEmailLogin]);

  const [
    showLogoutPromptForNotCheckinUser,
    setShowLogoutPromptForNotCheckinUser,
  ] = useState(false);
  useEffect(() => {
    if (currentUser?.accountId && eventRoleId === undefined && !isWebinar) {
      if (eventEntryType !== IEventCheckinType.INVITE_ONLY) {
        setShowLogoutPromptForNotCheckinUser(true);
      }
    } else {
      setShowLogoutPromptForNotCheckinUser(false);
    }
    // sending message to parent window
    if (currentUser?.accountId && eventRoleId) {
      setMessageToParentWindow('USER_AUTHORIZED', '');
    }
  }, [currentUser, eventRoleId, isWebinar]);

  useEffect(() => {
    if (notificationMode) {
      setNotificationMode(false);
    }
  }, [notificationMode]);

  useEffect(() => {
    if (!event?.enableHelpdesk || isEmbedView) {
      return;
    }
    const tawkToPropertyId = tawkToDetails?.tawktoPropertyId;
    const tawkToKey = tawkToDetails?.tawktoWidgetId;
    if (tawkToPropertyId && tawkToKey) {
      const tawk = new tawkTo(tawkToPropertyId, tawkToKey);
      tawk.showWidget();
    }
  }, [event?.enableHelpdesk, tawkToDetails, isEmbedView]);

  useEffect(() => {
    if (!checkRegistrationExists) {
      setShowLoginOption(false);
    }
  }, [checkRegistrationExists]);



  useEffect(() => {
    if (
      registrationStep === IAccountRegistrationEnum.RESET_PASSWORD ||
      registrationStep === IAccountRegistrationEnum.RESET_PASSWORD_SUCCESS
    ) {
      setValidMessage(false);
      setShowLoginOption(true);
      return;
    }

    if (isEventDone) {
      setValidMessage(true);
    } else if (isEventBefore) {
      if (
        eventEntryType === IEventCheckinType.INVITE_ONLY ||
        eventEntryType === IEventCheckinType.DIRECT_CHECKIN
      ) {
        if (isSpeakerPage && currentUser.accountId === undefined) {
          setValidMessage(false);
        } else {
          setValidMessage(true);
        }
      } else if (
        currentUser.accountId !== undefined &&
        eventRoleId !== undefined
      ) {
        setValidMessage(true);
      } else {
        setValidMessage(false);
      }
    } else if (isEventLive) {
      if (currentUser.accountId !== undefined && eventRoleId !== undefined) {
        setValidMessage(true);
      } else {
        setValidMessage(false);
      }
    } else {
      setValidMessage(false);
    }

    // Prompt a guest account to logout if at an attendee landing page for another
    //  event. (Guest account can only sign up for one event.)
    const showGuestLogoutScreen: boolean =
      currentUser.isGuestAccount && _isEmptyObj(currentUserEventPermissions);

    if (showGuestLogoutScreen) {
      setValidMessage(true);
    }

    //Scenario when attendee logged in to other event and tries to access invite only event
    //show Invite Only event message upfront when page load.
    const showInviteOnlyEventScreen: boolean =
      currentUser?.accountId &&
      _isEmptyObj(currentUserEventPermissions) &&
      eventEntryType === IEventCheckinType.INVITE_ONLY;

    if (showInviteOnlyEventScreen) {
      setValidMessage(true);
    }
  }, [
    eventId,
    isEventDone,
    isEventBefore,
    isEventLive,
    registrationStep,
    currentUser,
    eventRoleId,
    currentUserEventPermissions,
    eventEntryType,
  ]);

  const signOutClickHandler = () => {
    // Logout the user
    dispatch({
      type: 'account/logoutNoRedirect',
    });
    setValidMessage(false);
  };

  const setGuestAuthState = () => {
    // Take user to the final guest auth form
    setShowLoginOption(true);
    dispatch({
      type: 'account/setRegistrationStep',
      payload: { registrationStep: IAccountRegistrationEnum.GUEST_LOGIN },
    });
  };

  const updateLoginMethod = (loginType: ILoginType) => {
    dispatch({
      type: 'account/setSelectedLoginMethod',
      payload: { selectedLoginMethod: loginType },
    });
  };

  if (event?.status === IEventStatusOptions.CANCELED) {
    return (
      <div className={styles.canceledEventInfo}>
        <Text
          text="Registration is unavailable because the event has been canceled."
          textColor={ITextColors.BLACK}
        />
      </div>
    );
  }

  const isLegacyEmailLogin: boolean = getEmbedLegacyCustomFormAuthEnabled(
    eventId,
    isEmbedView,
  );
  if (isLegacyEmailLogin && _isEmptyObj(currentUser)) {
    return (
      <div className={styles.formContainer}>
        <BasicCheckinForm
          buttonBackgroundColor={formBgColour}
          buttonFontcolor={formFontColour}
          getDisclaimerMessage={null}
          isDisclaimerRequired={false}
          checkInWithEmail={true}
          eventEntryType={eventEntryType}
        />
        <TermsAndConditions />
      </div>
    );
  }

  const timerBoxContainerClasses = classnames(styles.timerBoxContainer);

  const isEventEntryNotRegistrationType =
    eventEntryType !== IEventCheckinType.REGISTRATION;
  const isCurrentUserEmpty = _isEmptyObj(currentUser);
  const showLoginOptions =
    !isSpeakerPage &&
    isEventLive &&
    !showLoginOption &&
    checkRegistrationExists &&
    !onlyGuestAuthIsEnabled &&
    (isEventEntryNotRegistrationType || !isCurrentUserEmpty);

  const showLoginButton = isEventLive &&
    !showLoginOption &&
    checkRegistrationExists &&
    !onlyGuestAuthIsEnabled;

  const showCountDownTimer =
    (!showValidMessage ||
      showLogoutPromptForNotCheckinUser ||
      !shouldUpdatePendingCustomFields) &&
    isEventBefore &&
    !isEmbedView &&
    !isLoginFlowOnly;

  return (
    <div className={styles.formContainer}>
      {showCountDownTimer && (
        <div className={timerBoxContainerClasses}>
          <div
            className={classnames(styles.timerBox, {
              [styles.loginFlowV3TimerBox]: isLoginFlowOnly,
            })}
          >
            <NewLandingPageCountdownTimer />
          </div>
        </div>
      )}

      {isSeriesEvent &&
        <RegistrationCustomFields
          event={event}
          isSeriesEvent={isSeriesEvent}
          landingPageObject={landingPageObject}
          currentUser={currentUser}
          currentUserEventPermissions={currentUserEventPermissions}
          buttonStyle={buttonStyle}
          role={role}
          setNotificationMode={setNotificationMode}
          setCheckRegistrationExists={setCheckRegistrationExists}
          email={email}
          isEmbedView={isEmbedView}
          isSpeakerPage={isSpeakerPage}
          setShowLoginOption={setShowLoginOption}
          setGuestAuthState={setGuestAuthState}
          guestModeEnabled={guestModeEnabled}
          isGuestLogin={false}
          onlyGuestAuthIsEnabled={false}
          setIsRegisteredOrAlreadyRegistered={
            setIsRegisteredOrAlreadyRegistered
          }
          showLoginButton={showLoginButton}
          isEventBefore={isEventBefore}
        />
      }

      {!showValidMessage && !showLogoutPromptForNotCheckinUser && !isSeriesEvent && (
        <div>
          {(showLoginOptions || isRegisteredOrAlreadyRegistered) && (
              <div className={styles.registerContainerOne}>
                {isCurrentUserEmpty && (isEventEntryNotRegistrationType || isRegisteredOrAlreadyRegistered) && (
                  <>
                    <div
                      className={styles.alreadyRegisteredText}
                      onClick={() => setShowLoginOption(true)}
                    >
                      {!isSpeakerPage && `Already Registered?`}
                      <span className={styles.alreadyRegisteredTextBold}>
                        <span className={styles.loginBtn}>
                          {!isSpeakerPage ? `Login now` : `Speaker Check-In`}
                        </span>
                      </span>
                    </div>
                    {guestModeEnabled && (
                      <div>
                        <div> - or -</div>
                        <div
                          className={styles.guestLoginText}
                          onClick={() => setGuestAuthState()}
                        >
                          Login as a guest
                        </div>
                      </div>
                    )}
                  </>
                )}
                {!isCurrentUserEmpty && (
                  <div className={styles.logoutContainer}>
                    {`Logged in as ${
                      currentUser.firstName ? currentUser.firstName : 'Event'
                    } ${
                      currentUser.lastName ? currentUser.lastName : 'Attendee'
                    }.`}{' '}
                    <span
                      className={styles.logoutBtn}
                      onClick={signOutClickHandler}
                    >
                      Log Out
                    </span>
                  </div>
                )}
              </div>
            )}
          {!isSpeakerPage && (
            <>
              {!checkRegistrationExists && (
                <div className={styles.mainHeading}>
                  <span
                    className={styles.registrationArrow}
                    onClick={() => {
                      setShowLoginOption(true);
                      setCheckRegistrationExists(true);
                      setEmail('');
                    }}
                  >
                    <ArrowLeft />
                  </span>
                  {eventEntryType === IEventCheckinType.INVITE_ONLY ? (
                    <span>
                      Invite only event <br /> Entered email has no access for
                      this event
                    </span>
                  ) : (
                    <span>
                      Register for this event
                    </span>
                  )}
                </div>
              )}
              {!showLoginOption && !onlyGuestAuthIsEnabled && !isLoginFlowOnly && (
                <div>
                  {eventEntryType === IEventCheckinType.REGISTRATION && (
                    <RegistrationCustomFields
                      event={event}
                      landingPageObject={landingPageObject}
                      currentUser={currentUser}
                      currentUserEventPermissions={currentUserEventPermissions}
                      buttonStyle={buttonStyle}
                      role={role}
                      setNotificationMode={setNotificationMode}
                      setCheckRegistrationExists={setCheckRegistrationExists}
                      email={email}
                      isEmbedView={isEmbedView}
                      isSpeakerPage={isSpeakerPage}
                      setShowLoginOption={setShowLoginOption}
                      setGuestAuthState={setGuestAuthState}
                      guestModeEnabled={guestModeEnabled}
                      isGuestLogin={false}
                      onlyGuestAuthIsEnabled={false}
                      setIsRegisteredOrAlreadyRegistered={
                        setIsRegisteredOrAlreadyRegistered
                      }
                      showLoginButton={showLoginButton}
                      isEventBefore={isEventBefore}
                    />
                  )}
                </div>
              )}
              {!showLoginOption && onlyGuestAuthIsEnabled && (
                <div>
                  <RegistrationCustomFields
                    event={event}
                    landingPageObject={landingPageObject}
                    currentUser={currentUser}
                    currentUserEventPermissions={currentUserEventPermissions}
                    buttonStyle={buttonStyle}
                    role={role}
                    setNotificationMode={setNotificationMode}
                    setCheckRegistrationExists={setCheckRegistrationExists}
                    email={email}
                    isEmbedView={isEmbedView}
                    isSpeakerPage={isSpeakerPage}
                    setShowLoginOption={setShowLoginOption}
                    setGuestAuthState={setGuestAuthState}
                    guestModeEnabled={guestModeEnabled}
                    isGuestLogin={true}
                    onlyGuestAuthIsEnabled={true}
                    setIsRegisteredOrAlreadyRegistered={
                      setIsRegisteredOrAlreadyRegistered
                    }
                     showLoginButton={showLoginButton}
                     isEventBefore={isEventBefore}
                  />
                </div>
              )}
              {showLoginOption && (
                <LandingPageAccountFormSection
                  event={event}
                  currentUserEventPermissions={currentUserEventPermissions}
                  currentUser={currentUser}
                  landingPageObject={landingPageObject}
                  buttonStyle={buttonStyle}
                  setNotificationMode={setNotificationMode}
                  email={email}
                  setEmail={setEmail}
                  isLogin={true}
                  isEventLive={isEventLive}
                  setShowLoginOption={setShowLoginOption}
                  setCheckRegistrationExists={setCheckRegistrationExists}
                  isSpeakerPage={isSpeakerPage}
                  otpInitiated={otpInitiated}
                  setOtpInitiated={setOtpInitiated}
                  setShowLogoutPromptForNotCheckinUser={
                    setShowLogoutPromptForNotCheckinUser
                  }
                  role={role}
                  isEmbedView={isEmbedView}
                  isLoginFlowOnly={isLoginFlowOnly}
                  isEventBefore={isEventBefore}
                />
              )}
              {!isLoginFlowOnly && <TermsAndConditions />}
            </>
          )}
          {isSpeakerPage && (
            <>
              {currentUser?.accountId !== undefined &&
                eventRoleId === undefined && (
                  <div className={styles.mainHeading}>
                    <span
                      className={styles.registrationArrow}
                      onClick={() => {
                        signOutClickHandler();
                        setEmail('');
                      }}
                    >
                      <ArrowLeft />
                    </span>
                    Not Invited / Registered for this Event
                  </div>
                )}
              <LandingPageAccountFormSection
                event={event}
                currentUserEventPermissions={currentUserEventPermissions}
                currentUser={currentUser}
                landingPageObject={landingPageObject}
                buttonStyle={buttonStyle}
                setNotificationMode={setNotificationMode}
                email={email}
                setEmail={setEmail}
                isLogin={true}
                isEventLive={isEventLive}
                setShowLoginOption={setShowLoginOption}
                setCheckRegistrationExists={setCheckRegistrationExists}
                isSpeakerPage={isSpeakerPage}
                otpInitiated={otpInitiated}
                setOtpInitiated={setOtpInitiated}
                setShowLogoutPromptForNotCheckinUser={
                  setShowLogoutPromptForNotCheckinUser
                }
                role={role}
                isEmbedView={isEmbedView}
                isLoginFlowOnly={isLoginFlowOnly}
                isEventBefore={isEventBefore}
              />
            </>
          )}
        </div>
      )}
      {showValidMessage &&
        !showLogoutPromptForNotCheckinUser &&
        shouldUpdatePendingCustomFields && !isSeriesEvent && (
          <RegistrationCustomFields
            event={event}
            landingPageObject={landingPageObject}
            currentUser={currentUser}
            currentUserEventPermissions={currentUserEventPermissions}
            buttonStyle={buttonStyle}
            role={role}
            setNotificationMode={setNotificationMode}
            setCheckRegistrationExists={setCheckRegistrationExists}
            email={email}
            shouldUpdateCustomField={shouldUpdatePendingCustomFields}
            isEmbedView={isEmbedView}
            isGuestLogin={false}
            onlyGuestAuthIsEnabled={false}
            setShowLoginOption={setShowLoginOption}
            setIsRegisteredOrAlreadyRegistered={
              setIsRegisteredOrAlreadyRegistered
            }
             showLoginButton={showLoginButton}
             isEventBefore={isEventBefore}
          />
        )}
      {showValidMessage &&
        !showLogoutPromptForNotCheckinUser &&
        !shouldUpdatePendingCustomFields && !isSeriesEvent && (
          //This component is for displaying proper message.
          //eg: Before event start, After event ended, (Registration, Invite, Direct Checkin) Scenarios
          <CheckinValidation
            event={event}
            currentUserEventPermissions={currentUserEventPermissions}
            currentUser={currentUser}
            landingPageObject={landingPageObject}
            isEventLive={isEventLive}
            isEventDone={isEventDone}
            isEventBefore={isEventBefore}
            eventRoleId={eventRoleId}
            isEmbedView={isEmbedView}
            isSpeakerPage={isSpeakerPage}
          />
        )}
      {showLogoutPromptForNotCheckinUser && !isSeriesEvent && (
        <div className={styles.logoutPromptContainer}>
          <LogoutPromptForNotCheckedinUsers
            currentUser={currentUser}
            landingPageObject={landingPageObject}
            isSpeakerPage={isSpeakerPage}
            redirectToAttendeePageForDuda={redirectToAttendeePageForDuda}
            isEmbedView={isEmbedView}
          />
        </div>
      )}
      <Notification
        contentType={INotificationContentTypes.ATTENDEE_DELETION_LANDING_PAGE}
        position={INotificationPositionTypes.CENTER}
        isVisible={notificationMode}
        durationTime={10000}
      />
      <MagicLinkConfirmationModal
        magicLinkWithDifferentEmail={magicLinkWithDifferentEmail}
        currentUser={currentUser}
        setConfirmDifferentEmailLogin={setConfirmDifferentEmailLogin}
        setMagicLinkWithDifferentEmail={setMagicLinkWithDifferentEmail}
        redirectToLandingPage={redirectToLandingPage}
        isEmbedView={isEmbedView}
      />
    </div>
  );
};

export default ConfigAuthComponents;
